export class AddressContract {
  addressClassId: number;
  city: string;
  line1: string;
  line2: string;
  stateClassId: number;
  zipCode: string;

  constructor() {
    this.addressClassId = 0;
    this.city = '';
    this.line1 = '';
    this.line2 = '';
    this.stateClassId = 0;
    this.zipCode = '';
  }
}

export class EmailContract {
  id: number;
  emailAddresses: string;
  preferred: boolean;

  constructor() {
    this.id = 0;
    this.emailAddresses = '';
    this.preferred = false;
  }
}

export class PhoneContract {
  id: number;
  areaCode: number;
  exchange: number;
  number: number;
  phoneClassId: number;
  preferred: boolean;
  sms: boolean;

  constructor() {
    this.id = 0;
    this.areaCode = 0;
    this.exchange = 0;
    this.number = 0;
    this.phoneClassId = 0;
    this.preferred = false;
    this.sms = false;
  }
}


export class CommunicationContract {
  email: EmailContract[];
  phone: PhoneContract[];

  constructor() {
    this.email = [new EmailContract()];
    this.phone = [new PhoneContract()];
  }
}

export class Contact {
  address: AddressContract;
  communications: CommunicationContract;

  constructor() {
    this.address = new AddressContract();
    this.communications = new CommunicationContract();
  }
}
